import Vue from 'vue';
import Router from 'vue-router';
import MtaH5 from 'mta-h5-analysis';

import SimpleLayout from './components/SimpleLayout.vue';
import store from './store';
import i18n from './i18n';

import Home from './views/home/index.vue';
import Collections from './views/Collections.vue';
import Goods from './views/Goods.vue';
import { fetchGoodsSeries, fetchTags } from './api/index';


Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/en/home',
  },
  {
    path: '/:locale',
    name: 'locale',
    redirect: 'home',
    component: SimpleLayout,
    children: [{
      path: 'home',
      name: 'home',
      component: Home,
    },
    {
      path: 'products',
      redirect: 'products/all',
    },
    {
      path: 'products/:seriesId',
      name: 'products',
      component: Collections,
    },
    {
      path: 'products/:seriesId/:id',
      name: 'product-detail',
      component: Goods,
      meta: { darkHeader: true },
    },
    {
      path: 'xband',
      name: 'xband',
      component: () => import('./views/Xband.vue'),
      // 首屏顶部为浅色，头部需用深色文字/logo
      meta: { darkHeader: true },
    },
    {
      path: 'about',
      name: 'about',
      redirect: 'history',
    },
    {
      path: 'history',
      name: 'history',
      component: () => import('./views/History.vue'),
    },
    {
      path: 'craft',
      name: 'craft',
      component: () => import('./views/Craft.vue'),
    },
    {
      path: 'search',
      name: 'search',
      component: () => import('./views/Search.vue'),
    },
    {
      path: 'news',
      name: 'news',
      component: () => import('./views/News.vue'),
    },
    {
      path: 'news/:id',
      name: 'news-detail',
      meta: { darkHeader: true },
      component: () => import('./views/NewsDetail.vue'),
    },
    {
      path: 'services',
      name: 'services',
      redirect: 'after-sales',
    },
    {
      path: 'after-sales',
      name: 'after-sales',
      component: () => import('./views/AfterSales.vue'),
    },
    {
      path: 'legal',
      name: 'legal',
      component: () => import('./views/Legal.vue'),
    },
    {
      path: 'questions',
      name: 'questions',
      component: () => import('./views/Questions.vue'),
    },
    {
      path: 'company',
      name: 'company',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: 'shops',
      name: 'shops',
      component: () => import('./views/ShopSearch.vue'),
    },
    {
      path: 'shops/:id',
      name: 'shop-detail',
      meta: { darkHeader: true },
      component: () => import('./views/ShopDetail.vue'),
    },
    {
      path: 'shop-list',
      name: 'shop-list',
      meta: { darkHeader: true },
      component: () => import('./views/ShopList.vue'),
    },
    // 兜底：未匹配到的路径显示 404 页面
    {
      path: '*',
      name: 'not-found',
      component: () => import('./views/NotFound.vue'),
    }],
  },
];

const router = new Router({
  // history 模式：去掉 URL 中的 #。需要服务端把所有未匹配路径回退到 index.html，
  // 否则刷新 /cn/products/10 这类深层路由会 404
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
    // return 期望滚动到哪个的位置
    // if (savedPosition) {
    //   return savedPosition;
    // }
    // const position = {};
    // if (to.hash) {
    //   position.selector = to.hash;

    //   if (document.querySelector(to.hash)) {
    //     return position;
    //   }

    //   // if the returned position is falsy or an empty object,
    //   // will retain current scroll position.
    //   return false;
    // }
    // return new Promise((resolve) => {
    //   // check if any matched route config has meta that requires scrolling to top
    //   // if (to.matched.some(m => m.meta.scrollToTop)) {
    //   // coords will be used if no selector is provided,
    //   // or if the selector didn't match any element.
    //   position.x = 0;
    //   position.y = 0;
    //   // }

    //   // wait for the out transition to complete (if necessary)
    //   this.app.$root.$once('triggerScroll', () => {
    //     // if the resolved position is falsy or an empty object,
    //     // will retain current scroll position.
    //     resolve(position);
    //   });
    // });
  },
});

router.beforeEach(async (to, from, next) => {
  // 跳转页面前关闭侧边栏
  store.commit('setDrawer', { visible: false });
  if (to.params.locale !== from.params.locale) {
    store.commit('toggleLoadingScene', 0);
    try {
      i18n.locale = to.params.locale;
      const goodsSeries = await fetchGoodsSeries();
      store.commit('updateSeries', goodsSeries);
      store.commit('toggleLoadingScene', 20);
      const typeTags = await fetchTags();
      store.commit('updateTags', typeTags);
      store.commit('toggleLoadingScene', 40);
    } catch (e) {
      // 数据加载失败也必须放行：否则 next() 永远不会被调用，整个页面会卡死在 loading 上
      console.error('[router] 切换语言时数据加载失败', e);
    }
    setTimeout(() => {
      next();
    }, 300);
  } else if (to.name !== from.name) {
    store.commit('toggleLoadingScene', 0);
    setTimeout(() => {
      next();
    }, 300);
  } else {
    next();
  }
});

// 看门狗：进度只要还在推进就重新计时，只有「停住不走」时才兜底补一个 100。
// 用于兜住页面漏报 100 的情况（例如语言切换时组件复用、页面的 updated() 不再触发），
// 避免遮罩永远停在半途、只能刷新页面。
const LOADING_STUCK_TIMEOUT = 2000;
let loadingSafetyTimer = null;

function armLoadingSafetyTimer() {
  clearTimeout(loadingSafetyTimer);
  loadingSafetyTimer = setTimeout(() => {
    if (store.state.loadingScene.precent < 100) {
      store.commit('toggleLoadingScene', 100);
    }
  }, LOADING_STUCK_TIMEOUT);
}

store.subscribe((mutation) => {
  if (mutation.type === 'toggleLoadingScene') armLoadingSafetyTimer();
});

router.afterEach(() => {
  armLoadingSafetyTimer();
  if (process.env.NODE_ENV === 'production') {
    MtaH5.pgv();
  }
});

router.onReady(() => {
  // 加载路由后隐藏 loadingScene
  store.commit('toggleLoadingScene', 100);
});

export default router;
